<template>
  <div class="flex items-centered space-x-3 justify-start">
    <input 
      type="checkbox"
      :id="`agreement-${agreement.id}`"
      v-model="isAccepted"
      class="w-5 h-5 mt-1 rounded border-gray-300 text-primary-500 focus:ring-2 focus:ring-primary-500 focus:ring-offset-0 cursor-pointer"
    />
    <label :for="`agreement-${agreement.id}`" class="flex-1 cursor-pointer">
      <span :class="`text-xs font-light transition-colors ${error ? 'text-red-600' : 'text-slate-900'}`">
        {{ agreement.title }} <span v-if="agreement.required" class="text-red-500">*</span>
      </span>
      <a
        v-if="agreement.document_url"
        :href="agreement.document_url"
        target="_blank"
        rel="noopener noreferrer"
        class="ml-2 text-primary-500 hover:text-primary-600 hover:underline text-xs font-normal"
      >
        Przeczytaj
      </a>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AgreementCheckBox',
  props: {
    agreement: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: [Boolean, String],
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
  computed: {
    isAccepted: {
      get() {
        return this.modelValue === true || this.modelValue === 'TAK';
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>